
import { CompanyDetailsCard } from './CompanyDetailsCard';
import { CompanyBioCard } from './CompanyBioCard';
import { CompanyOnlinePresenceCard } from './CompanyOnlinePresenceCard';
import { CompanyActionButtons } from './CompanyActionButtons';

interface CompanyDataDisplayProps {
  companyData: any;
  handleViewCompanyProfile: () => void;
}

export function CompanyDataDisplay({ companyData, handleViewCompanyProfile }: CompanyDataDisplayProps) {
  return (
    <div className="space-y-6">
      <CompanyDetailsCard companyData={companyData} />
      <CompanyBioCard bio={companyData.bio} />
      <CompanyOnlinePresenceCard
        website={companyData.website}
        twitterUrl={companyData.twitter_url}
        instagramUrl={companyData.instagram_url}
        linkedinUrl={companyData.linkedin_url}
      />
      <CompanyActionButtons handleViewCompanyProfile={handleViewCompanyProfile} />
    </div>
  );
}
